export default __webpack_public_path__ + "static/media/deleteWarning.52c48394.svg";